"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillCtmlFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillCtmlFilled = function MealVkusvillCtmlFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M35.995 6.559a.456.456 0 00-.26-.48.435.435 0 00-.524.132 11.939 11.939 0 01-3.928 3.059 11.749 11.749 0 01-4.81 1.171 8.93 8.93 0 00-6.389-1.818 8.91 8.91 0 00-6.488 1.818A11.729 11.729 0 018.762 9.28a11.918 11.918 0 01-3.945-3.07.435.435 0 00-.77.038.457.457 0 00-.034.31 11.874 11.874 0 002.61 5.47 11.585 11.585 0 004.944 3.418c-.033.6-.033 1.2 0 1.799-.009 2.982.859 5.9 2.49 8.377.424.596.655 1.31.664 2.044v.592c0 .623.12 1.24.354 1.814a4.746 4.746 0 001.01 1.538c.433.44.947.79 1.513 1.028a4.593 4.593 0 001.783.361h.985a4.61 4.61 0 001.783-.36 4.656 4.656 0 001.512-1.029c.433-.44.776-.962 1.01-1.538a4.811 4.811 0 00.355-1.814v-.633a3.53 3.53 0 01.663-2.043 14.943 14.943 0 002.732-8.358c0-.621-.034-1.242-.1-1.86a11.517 11.517 0 005.001-3.353 11.806 11.806 0 002.673-5.453z",
    fill: "#97BA1E"
  }));
};

exports.MealVkusvillCtmlFilled = MealVkusvillCtmlFilled;
var _default = MealVkusvillCtmlFilled;
exports.default = _default;